export default {
  bind: function(el) {
    el.addEventListener("click", function(event) {
      rippler(event, el);
    });

    function rippler(event, el) {
      let ripple = document.createElement("div");
      ripple.className = "ripple";
      ripple.style.width = "1rem";
      ripple.style.height = "1rem";
      ripple.style.backgroundColor = "#2A528E";
      ripple.style.borderRadius = "50%";

      ripple.style.position = "fixed";
      ripple.style.left = `${event.clientX / 10}rem`;
      ripple.style.top = `${event.clientY / 10}rem`;
      ripple.style.zIndex = "999";
      ripple.style.transformOrigin = "center";
      ripple.style.transition = `all 0.3s cubic-bezier(0.4, 0, 0.2, 1)`;
      ripple.style.opacity = "0.2";

      el.appendChild(ripple);

      setTimeout(function() {
        ripple.style.transform = "scale(5)";
      }, 0);

      clearRipple();

      function clearRipple() {
        setTimeout(function() {
          ripple.style.opacity = "0";
        }, 250);

        setTimeout(function() {
          ripple.parentNode.removeChild(ripple);
        }, 850);
      }
    }
    // const transitionTime = 600;
    // const isReverse = !!binding.modifiers.reverse;
    // let color = Tokens.color_midnight;

    // if (isReverse) {
    //   color = Tokens.color_white;
    // }

    // el.addEventListener("click", function(event) {
    //   rippler(event, el);
    // });

    // function rippler(event, el) {
    //   let ripple = document.createElement("div");
    //   ripple.className = "wms-ripple";
    //   ripple.style.width = "1rem";
    //   ripple.style.height = "1rem";
    //   ripple.style.backgroundColor = color;
    //   ripple.style.borderRadius = Tokens["border-radius_circle"];

    //   ripple.style.position = "fixed";
    //   ripple.style.left = `${event.clientX / 10}rem`;
    //   ripple.style.top = `${event.clientY / 10}rem`;
    //   ripple.style.zIndex = Tokens.z_index_modal;
    //   ripple.style.transformOrigin = "center";
    //   ripple.style.transition = `all ${transitionTime}ms cubic-bezier(0.4, 0, 0.2, 1)`;
    //   ripple.style.opacity = "0.2";

    //   el.appendChild(ripple);

    //   setTimeout(function() {
    //     ripple.style.transform = "scale(5)";
    //   }, 0);

    //   clearRipple();

    //   function clearRipple() {
    //     setTimeout(function() {
    //       ripple.style.opacity = "0";
    //     }, 250);

    //     setTimeout(function() {
    //       ripple.parentNode.removeChild(ripple);
    //     }, 850);
    //   }
    // }
  }
};
